import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    root: {
        marginTop: '1.2rem',
    },
}));

const TextFieldComp = ({ label, variant, className, isCapital, ...rest }) => {
    const classes = useStyles();
    return (
        <TextField
            label={label}
            variant={variant}
            placeholder={label}
            className={clsx(classes.root, className)}
            inputProps={isCapital ? { style: { textTransform: "uppercase" } } : { style: { textTransform: "none" } }}
            {...rest}
        />
    );
};

TextFieldComp.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
};

TextFieldComp.defaultProps = {
    className: '',
    variant: "outlined",
    size: "medium"
};

export default TextFieldComp;